import { useEffect, useRef, useState } from 'react';

export default function BlockLoading({ block, settingsFunnel }) {
    // Set defaults safely
    if (block.destinationType === null) {
        block.destinationType = 'step';
        block.target = null;
    }
    if (block?.duration === undefined || block?.duration === null) {
        block.duration = 3000;
    }
    const duration = Number(block?.duration) || 3000;
    if (block.title === undefined) {
        block.title = "Carregando...";
    }
    if (block.description === undefined) {
        block.description = "Fusce vitae tellus in risus sagittis condimentum!";
    }
    const title = block?.title;
    const description = block?.description;
    const color = block?.color || settingsFunnel.primaryColor;

    const [progress, setProgress] = useState(0);
    const animationRef = useRef();

    useEffect(() => {
        setProgress(0);

        const start = performance.now();

        function animate(now) {
            const elapsed = now - start;
            const percent = Math.min((elapsed / duration) * 100, 100);
            setProgress(percent);
            if (percent < 100) {
                animationRef.current = requestAnimationFrame(animate);
            }
        }
        animationRef.current = requestAnimationFrame(animate);

        return () => {
            if (animationRef.current) cancelAnimationFrame(animationRef.current);
        };
    }, [duration]);

    return (
        <div className="rounded-xl w-full">
            <div className="flex justify-between items-center mb-1 w-full">
                <span className="font-semibold text-sm" style={{ color: settingsFunnel.textColor, fontFamily: settingsFunnel.font }}>
                    <b>{title}</b>
                </span>
                <span className="text-gray-500 text-xs" style={{ color: settingsFunnel.textColor, fontFamily: settingsFunnel.font }}>
                    {Math.round(progress)}%
                </span>
            </div>
            <div className="w-full h-3 bg-gray-100 rounded-full overflow-hidden mb-1">
                <div
                    className="h-full"
                    style={{
                        width: `${progress}%`,
                        backgroundColor: color,
                        // No transition here! The JS controls the progress smoothly.
                    }}
                />
            </div>
            <div className="text-center text-sm" style={{ color: settingsFunnel.textColor }}>
                {description}
            </div>
        </div>
    );
}
